"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _organizations = require("@/api/organizations");
var _ga = require("@/utils/ga");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OragnizatioinDetail',
  props: {
    displayType: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      existingEmailDomains: {},
      fullscreenloading: false,
      createButtonDisable: false,
      showThumbnailUploadErrMsg: false,
      tagInputValue: '',
      /* for tags component user */
      tagInputVisible: false,
      /* for tags component user */
      file: null,
      organizationForm: {
        id: '',
        name: '',
        emailDomains: [],
        logo: {
          url: ""
        }
      }
    };
  },
  created: function created() {
    this.getList();
    if (this.displayType === 'edit') {
      this.getOrganization();
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _organizations.getAllOrganizations)(token).then(function (response) {
        var currentOrgId = _this.$route.params.id;
        var organizations = response.data.rows;
        var domainToOrgName = {};
        organizations.forEach(function (org) {
          if (currentOrgId !== org.id) {
            // Only add domains for organizations that are not the current one
            (org.emailDomains || []).forEach(function (domain) {
              domainToOrgName[domain.toLowerCase()] = org.name;
            });
          }
        });
        _this.existingEmailDomains = domainToOrgName;
      }).catch(function (error) {
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    doAddSave: function doAddSave() {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      if (this.organizationForm.name === "") {
        this.fullscreenloading = false;
        var msg = "Organization's Name is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.organizationForm.name.length > 100) {
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)("Organization's Name max length is 100", "error");
        return;
      }
      this.fullscreenloading = true;
      var payload = {
        name: this.organizationForm.name,
        emailDomains: this.organizationForm.emailDomains
      };
      (0, _organizations.createOrganization)(token, payload).then(function (response) {
        var data = response.data || {};
        var logo = data.logo || {};
        _this2.organizationForm = {
          id: data.id || '',
          name: data.name || '',
          emailDomains: data.emailDomains || [],
          logo: {
            url: logo.url || '' // 安全访问
          }
        };
        _this2.createButtonDisable = true;
        _this2.fullscreenloading = false;
        var msg = "".concat(response.data.name, " (").concat(response.data.id, ") is created.");
        (0, _log.displayPopupMessage)(msg, 'success');
        (0, _ga.writeGaEvent)(_this2, 'Create Oragization', "Create Oragization", oEmail, "Oragization ID: ".concat(_this2.organizationForm.id));
        // Close current tab first
        _this2.$store.dispatch('tagsView/delView', _this2.$route).then(function () {
          // Then navigate to the new page
          _this2.$router.push("/organizations/edit/".concat(response.data.id));
        });
      }).catch(function (error) {
        (0, _log.showDebugLog)('Oragization-createOragization-API-error', error);
        _this2.fullscreenloading = false;

        // 檢查是否是我們知道的API錯誤結構
        if (error.response && error.response.data && error.response.data.message) {
          // 只顯示API返回的message
          (0, _log.displayPopupMessage)(error.response.data.message, 'error');
        } else {
          // 其他網絡錯誤保持原樣
          (0, _log.displayPopupMessage)(error, 'error');
        }
      });
    },
    doSave: function doSave() {
      var _this3 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      var id = typeof this.$route.params.id === 'undefined' ? this.organizationForm.id : this.$route.params.id;
      if (this.organizationForm.name === "") {
        this.fullscreenloading = false;
        var msg = "Organization's Name is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.organizationForm.name.length > 100) {
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)("Organization's Name max length is 100", "error");
        return;
      }
      this.fullscreenloading = true;
      var payload = {
        name: this.organizationForm.name,
        emailDomains: this.organizationForm.emailDomains
      };
      var logo = this.organizationForm.logo || {};
      if (logo && logo.url) {
        delete logo.url;
        payload.logo = logo;
      }
      (0, _organizations.updateOrganizationById)(token, id, payload).then(function (response) {
        var data = response.data || {};
        var logo = data.logo || {};
        _this3.organizationForm = {
          id: data.id || '',
          name: data.name || '',
          emailDomains: data.emailDomains || [],
          logo: logo
        };
        var msg = "".concat(response.data.name, " (").concat(response.data.id, ") is updated.");
        (0, _log.displayPopupMessage)(msg, 'success');
        (0, _ga.writeGaEvent)(_this3, 'Edit Oragization', "Edit Oragization", oEmail, "Oragization ID: ".concat(_this3.organizationForm.id));
        _this3.fullscreenloading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('Oragization-updateOrganizationById-API-Error', error);
        _this3.fullscreenloading = false;
        // 檢查是否是我們知道的API錯誤結構
        if (error.response && error.response.data && error.response.data.message) {
          // 只顯示API返回的message
          (0, _log.displayPopupMessage)(error.response.data.message, 'error');
        } else {
          // 其他網絡錯誤保持原樣
          (0, _log.displayPopupMessage)(error, 'error');
        }
      });
    },
    doThumbnailUpload: function doThumbnailUpload() {
      var _this4 = this;
      (0, _log.showDebugLog)('Debug-uploadLogoFile', this.thumbnailFile);
      this.fullscreenloading = true;
      var thumbnailIconForm = new FormData();
      thumbnailIconForm.append('file', this.thumbnailFile);
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _organizations.uploadFile)(token, this.organizationForm.id, thumbnailIconForm).then(function (response) {
        _this4.fullscreenloading = false;
        _this4.showThumbnailUploadErrMsg = false;
        var data = response.data || {};
        _this4.organizationForm.logo = data || {};
      }).catch(function (error) {
        (0, _log.showDebugLog)('upload-organizatioin-logo-api-error', error);
        _this4.fullscreenloading = false;
        _this4.showThumbnailUploadErrMsg = true;
      });
    },
    chooseThumbnailFile: function chooseThumbnailFile(e) {
      if (e.target.files.length > 0) {
        (0, _log.showDebugLog)('Debug-uploadTrainingImg', e.target.files[0]);
        if (e.target.files[0].size <= 5 * 1024 * 1024) {
          this.thumbnailFile = e.target.files[0];
        } else {
          (0, _log.displayPopupMessage)('Image size should not be exceeded 5M', 'error');
          this.$refs.thumbfile.value = '';
        }
      }
    },
    getOrganization: function getOrganization() {
      var _this5 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var id = typeof this.$route.params.id === 'undefined' ? this.organizationForm.id : this.$route.params.id;
      this.fullscreenloading = true;
      (0, _organizations.getOrganizationById)(token, id).then(function (response) {
        _this5.fullscreenloading = false;
        (0, _log.showDebugLog)('getOrganizationId-API', response.data);
        var data = response.data || {};
        var logo = data.logo || {};
        _this5.organizationForm = {
          id: data.id || '',
          name: data.name || '',
          emailDomains: data.emailDomains || [],
          logo: logo
        };
      }).catch(function (error) {
        (0, _log.showDebugLog)('Organization-GetOrganizationId-API-Error', error);
        _this5.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    /* for tag component use */handleClose: function handleClose(tag) {
      this.organizationForm.emailDomains.splice(this.organizationForm.emailDomains.indexOf(tag), 1);
    },
    handleTagInputConfirm: function handleTagInputConfirm() {
      var inputValue = this.tagInputValue;

      // Check if inputValue is a valid email domain (simple regex)
      var domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (inputValue && domainRegex.test(inputValue) && this.organizationForm.emailDomains.indexOf(inputValue) < 0) {
        // Check if the domain already exists in the existingEmailDomains
        if (this.existingEmailDomains[inputValue.toLowerCase()]) {
          (0, _log.displayPopupMessage)('This email domain already used in the organization "' + this.existingEmailDomains[inputValue.toLowerCase()] + '".', 'error');
        } else {
          this.organizationForm.emailDomains.push(inputValue.toLowerCase());
        }
      } else if (inputValue && !domainRegex.test(inputValue)) {
        (0, _log.displayPopupMessage)('Please enter a valid email domain.', 'error');
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
    showTagInput: function showTagInput() {
      var _this6 = this;
      this.tagInputVisible = true;
      this.$nextTick(function (_) {
        _this6.$refs.saveTagInput.$refs.input.focus();
      });
    }
  }
};